import { cn } from "@/lib/utils";

interface PhotowallTvFrameProps {
  children: React.ReactNode;
  className?: string;
  hasStand?: boolean;
}

/** A slim TV bezel around a demo wall. */
export default function PhotowallTvFrame({
  children,
  className,
  hasStand = true,
}: PhotowallTvFrameProps): React.JSX.Element {
  return (
    <div className={cn("relative", className)}>
      <div className="rounded-[clamp(8px,1.4vw,18px)] bg-[#141110] p-[clamp(4px,0.7vw,10px)] shadow-[0_40px_80px_-30px_rgba(40,25,10,0.65),inset_0_0_0_1px_rgba(255,255,255,0.06)]">
        <div className="overflow-hidden rounded-[clamp(3px,0.5vw,6px)]">{children}</div>
      </div>
      {hasStand && (
        <div aria-hidden="true" className="mx-auto h-[clamp(10px,1.6vw,22px)] w-[22%] rounded-b-md bg-gradient-to-b from-[#1d1916] to-[#2c2622]" />
      )}
    </div>
  );
}
